/* eslint-disable */
import { CONFIG_S3_URL } from '../../common';

export interface ConfigResponse {
  [key: string]: any;
}
export const getConfigFromS3 = async (): Promise<ConfigResponse> => {
  try {
    const response = await fetch(CONFIG_S3_URL);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching config: ', error);
    throw error;
  }
};

export default getConfigFromS3;
